/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expired_Token_PasswordInputs */



/**
* | output |
* | --- |
* | "Your password reset period has expired To receive a new link by email, click the button below" |
*
* @param {Expired_Token_PasswordInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const expired_token_password = /** @type {((inputs?: Expired_Token_PasswordInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expired_Token_PasswordInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Your password reset period has expired\nTo receive a new link by email, click the button below")
	return /** @type {LocalizedString} */ ("Le délai de réinitialisation de votre mot de passe a expiré\nPour recevoir un nouveau lien par email, cliquer sur le bouton ci-dessous")
});